import { render, staticRenderFns } from "./iprograms.vue?vue&type=template&id=d44ecd76&"
import script from "./iprograms.vue?vue&type=script&lang=js&"
export * from "./iprograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports